import { render, staticRenderFns } from "./IncomeVerificationSetBankAccountNumber.vue?vue&type=template&id=5da3a111"
import script from "./IncomeVerificationSetBankAccountNumber.vue?vue&type=script&lang=js"
export * from "./IncomeVerificationSetBankAccountNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports